module.exports = {"511402001":"通惠街道","511402002":"大石桥街道","511402003":"苏祠街道","511402102":"太和镇","511402104":"尚义镇","511402105":"多悦镇","511402106":"秦家镇","511402107":"万胜镇","511402109":"思蒙镇","511402110":"修文镇","511402112":"松江镇","511402113":"崇礼镇","511402114":"富牛镇","511402115":"永寿镇","511402116":"三苏镇","511402121":"复兴镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511402.json
// module id = 2480
// module chunks = 0